module.exports = __webpack_public_path__ + "img/F972.deae7153.jpg";